import script from "./AgentsBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentsBoard.vue?vue&type=script&setup=true&lang=js"

import "./AgentsBoard.vue?vue&type=style&index=0&id=daffa084&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-daffa084"]])

export default __exports__